// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FilterIndustries_wrap___WVFL"};